import { gsap } from "gsap";

export class Simulation {
    constructor(FeaturesCanvas) {

        /**
         * Simulation setup
         */


        this.FeaturesCanvas = FeaturesCanvas;
        this.canvasMultiplier = FeaturesCanvas.canvasMultiplier;

        this.container = this.FeaturesCanvas.container;
        this.items = this.FeaturesCanvas.container.querySelectorAll('[data-feature-link]');

        this.radius = 10;

        this.handleResize();
    }

    handleResize() {

        this.metaballs = [];

        this.WIDTH = this.FeaturesCanvas.WIDTH;
        this.HEIGHT = this.FeaturesCanvas.HEIGHT;

        this.angleRoot = 4.5;
        this.angleDivider = ((this.WIDTH/1512)/2);
        this.angle = this.angleRoot/this.angleDivider;

        this.createBalls();
        this.renderCursor();
    }

    createBalls() {
        this.items.forEach((item, index) => {
            this.metaballs.push({
                x: this.WIDTH/2,
                y: this.HEIGHT/2,
                r: index % 2 ? this.radius*6.5 : this.radius*4.4,
                angle: index % 2 ? (this.angle*0.75) : (this.angle*0.9),
            });
        });

        // Cursor
        this.cursorIndex = this.metaballs.push({
            x: this.WIDTH/2,
            y: this.HEIGHT/2,
            r: this.radius*5,
            angle: this.angle*1.1,
        });

        // 1 - 5
        this.ball1to5index = this.metaballs.push({
            x: this.WIDTH/2,
            y: this.HEIGHT/2,
            r: this.radius*4,
            angle: this.angle*0.8,
        });

        // 4 - 2
        this.ball2to4index = this.metaballs.push({
            x: this.WIDTH/2,
            y: this.HEIGHT/2,
            r: this.radius*4,
            angle: this.angle*0.9,
        });

        // 7 - 3
        this.ball7to3index = this.metaballs.push({
            x: this.WIDTH/2,
            y: this.HEIGHT/2,
            r: this.radius*4,
            angle: this.angle*0.9,
        });

    }

    positionBalls() {
        this.positionArray = [];

        this.items.forEach((item, index) => {
            const heading = item.querySelector('h2');
            const rect = heading.getBoundingClientRect();
            const x = rect.left-20;
            const y = rect.top+11;

            const calculatedX = x*this.canvasMultiplier;
            const calculatedY = this.HEIGHT-((y+this.container.scrollTop)*this.canvasMultiplier);

            this.positionArray.push(
                [calculatedX, calculatedY]
            );

            gsap.set(this.metaballs[index], {
                x: calculatedX,
                y: calculatedY,
            });
        });


        gsap.set(this.metaballs[this.ball1to5index-1], {
            x: this.positionArray[0][0],
            y: this.positionArray[0][1],
        });

        gsap.set(this.metaballs[this.ball2to4index-1], {
            x: this.positionArray[3][0],
            y: this.positionArray[3][1],
        });

        gsap.set(this.metaballs[this.ball7to3index-1], {
            x: this.positionArray[6][0],
            y: this.positionArray[6][1],
        });

        this.setInMotion();
    }

    setInMotion() {

        // Pulse angle
        this.angleTimeline = gsap.timeline({
            repeat: -1,
            repeatDelay: 1,
            yoyo: true
        });

        this.items.forEach((item, index) => {
            this.angleTimeline.to(this.metaballs[index], {
                angle: index % 2 ? (this.angle*0.75) : (this.angle*0.9),

                duration: 8,
                ease: 'sine.inOut'
            }, 0);
        });

        // 1 - 5
        if(this.ball1to5tl) {
            this.ball1to5tl.killTweensOf();
            this.ball1to5tl.kill();
        }
        this.ball1to5tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true
        });

        this.ball1to5tl.to(this.metaballs[this.ball1to5index-1], {
            x: this.positionArray[4][0],
            y: this.positionArray[4][1],

            duration: 10,
            ease: 'sine.inOut'
        });

        // 4 - 2
        if(this.ball2to4tl) {
            this.ball2to4tl.killTweensOf();
            this.ball2to4tl.kill();
        }
        this.ball2to4tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true
        });

        this.ball2to4tl.to(this.metaballs[this.ball2to4index-1], {
            x: this.positionArray[1][0],
            y: this.positionArray[1][1],

            duration: 15,
            ease: 'sine.inOut'
        });

        // 7 - 3
        if(this.ball7to3tl) {
            this.ball7to3tl.killTweensOf();
            this.ball7to3tl.kill();
        }
        this.ball7to3tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0,
            yoyo: true
        });

        this.ball7to3tl.to(this.metaballs[this.ball7to3index-1], {
            x: this.positionArray[2][0],
            y: this.positionArray[2][1],

            duration: 10,
            ease: 'sine.inOut'
        });
    }

    renderCursor() {
        if(this.boundPointerMoveListener) {
            return;
        }
        this.boundPointerMoveListener = this.pointerMoveListener.bind(this);
        document.addEventListener('pointermove', this.boundPointerMoveListener);
    }

    pointerMoveListener(e) {
		this.clientX = e.clientX;
		this.clientY = e.clientY;
	}

    step(){
        if(this.clientX&this.clientY) {
            gsap.to(this.metaballs[this.cursorIndex-1], {
                x: (this.clientX*this.canvasMultiplier),
                y: this.HEIGHT - ((this.clientY+this.container.scrollTop)*this.canvasMultiplier),

                duration: 0.3,
                overwrite: 'auto',
                ease: 'none'
            });
        }
    }

    destroy() {
        document.removeEventListener('pointermove', this.boundPointerMoveListener);
    }
}
